import { ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from './render-extension';

export interface ResourceLinkOptions {
  name: string;
  text: ReactNode;
}

export interface ResourceLinkExtensionOptions
  extends ItemRenderExtensionOptions<ResourceLinkOptions> {}

export const ResourceLinkExtensions =
  createItemRenderExtensions<ResourceLinkExtensionOptions>({
    id: 'resource-link',
  });

export const createResourceLinkExtension = (
  options: ResourceLinkExtensionOptions,
) => {
  return createItemRenderExtension<ResourceLinkExtensionOptions>(options);
};

export const useResourceLinkExtensions = () => {
  return useItemRenderExtensions<ResourceLinkExtensionOptions>(
    ResourceLinkExtensions,
  );
};
